import { useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import styled from '@emotion/styled'
import Carousel from 'Components/Carousel'
import { Title } from 'mailup-web-components'
import { SelectTemplateButtons } from './SelectTemplateButtons'

import { carouselState } from 'Components/Carousel/recoil/carousel'
import {
  fetchTemplateStructureCallback,
  initTemplateCarouselCallback
} from 'Pages/Campaign/recoil/callbacks/carouselCallbacks'
import { campaignState } from 'Pages/Campaign/recoil/state/campaign'
import { pageState } from 'Pages/Campaign/recoil/state/page'
import { templatesState } from 'Pages/Campaign/recoil/state/templates'

const StyledHeader = styled.div`
  position: relative;
  width: 100%;
  height: 60px;
  padding: 10px;
  background: var(--pure-white);
  border-bottom: 1px solid var(--silver);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

const StyledText = styled.span`
  color: var(--boulder);
  margin-left: 8px;
`

const StyledContainer = styled.div`
  position: absolute;
  top: 60px;
  left: 0;
  height: 0px;
  width: 100vw;
  padding: 0;
  background-color: var(---mercury);
  transition: height 250ms ease-out;
  overflow: hidden;
  border-bottom: 1px solid var(--silver);
  z-index: 10;
  background-color: var(--wild-sand);
`

export const HeaderSelectTemplate = () => {
  const intl = useIntl()

  const carouselContainer = useRef(null)
  const { displayCarousel } = useRecoilValue(pageState)
  const {
    EmailOptions: { IdContentEndpoint }
  } = useRecoilValue(campaignState)
  const { selectedSlide } = useRecoilValue(carouselState)
  const { templates } = useRecoilValue(templatesState)
  const templateCallback = useRecoilCallback(initTemplateCarouselCallback, [])
  const fetchTemplateStructure = useRecoilCallback(
    fetchTemplateStructureCallback,
    []
  )

  useEffect(() => {
    carouselContainer.current.style.height = displayCarousel ? '246px' : '0px'
    carouselContainer.current.style.height = displayCarousel
      ? 'height 250ms ease-in'
      : 'height 250ms ease-out'
  }, [displayCarousel])

  useEffect(() => {
    if (templates.length && IdContentEndpoint) {
      const template = templates[selectedSlide] || templates[0]
      fetchTemplateStructure(template)
    }
  }, [selectedSlide, templates, IdContentEndpoint])

  return (
    <>
      <StyledHeader>
        <Title data-mu-test='header-campain-full-title'>
          {intl.formatMessage({
            id: 'Load.ContentsCampaignWizard.Step2TabEmail'
          })}
          :{' '}
          <StyledText>
            {intl.formatMessage({
              id: 'Load.ContentsCampaignWizard.TemplateSelezionatoPreview'
            })}
          </StyledText>
        </Title>
        <SelectTemplateButtons />
        <StyledContainer ref={carouselContainer}>
          <Carousel items={templates} getTemplateCallback={templateCallback} />
        </StyledContainer>
      </StyledHeader>
    </>
  )
}
